import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from 'src/app/store/session/session.service';
import { Router, RouteConfigLoadStart, ResolveStart, RouteConfigLoadEnd, ResolveEnd } from '@angular/router';
import { SessionQuery } from 'src/app/store/session/session.query';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { StatusRegisterResponse } from 'src/app/shared/model/login';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  animations: [SharedAnimations]
})
export class SignUpComponent implements OnInit {

  statusUser: string = null;
  showError = false;
  showSuccess = false;
  messageError = '';
  loading$: Observable<boolean>;
  loadingText: string;
  form: FormGroup;

  textError = '';

  constructor(
    private fb: FormBuilder,
    private sessionService: SessionService,
    private router: Router,
    private sessionQuery: SessionQuery,
  ) { }

  ngOnInit() {
    this.loading$ = this.sessionQuery.selectLoading();
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  signUp(values) {
    this.showError = false;
    this.loadingText = 'Aguarde...';
    this.sessionService.createUser(values.email).subscribe(response => {
      this.statusUser = response.status;
      if (response.status === StatusRegisterResponse.REGISTERED_USER) {
        this.showError = true;
      } else {
        this.showSuccess = true;
      }
    }, err => {
      this.showError = true;
      this.messageError = 'Falha ao realizar o seu cadastro. Tente novamente mais tarde.';
    });

  }

  closeAlert() {
    this.showError = false;
  }

}
